import { initialize } from '@factry/base'
import '@factry/bulma/scss/bulma.scss'
import '@fortawesome/fontawesome-free/css/all.min.css'
import background from '@factry/user-manager/src/assets/background-5.jpg'
import App from './App.svelte'
import logo from './assets/surahammars.png'

initialize({
  availableLocales: ['sv-SE', 'en'],
  background,
  basePath: import.meta.env.VITE_BASE_PATH,
  defaultLocale: 'sv-SE',
  logo,
  logoAlt: 'Surahammars',
  test: import.meta.env.VITE_TEST,
  versions: import.meta.env.VITE_VERSIONS,
  organization: 'surahammars',
})

const app = new App({
  target: document.body,
})

export default app
